import React from "react";
import { burger } from "./burgerData";
import Heading from "./Heading";
function Burger() {
  return (
    <>
      <a href="/" id="burger"> </a>
      <div className="h-fit w-full p-4"  >
        <Heading heading="Burger" />
        {burger.map((burger) => {
          return (
            <React.Fragment key={burger.id} >
              <div className="flex p-4 [&>*]:p-3 justify-center my-5 shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl" >
                <div
                  className="flex flex-col text-base font-medium font-fancy border-r-2 border-r-gray-700"
                >
                  <p className="text-lg font-bold">Meal</p>
                  <p>{burger.name}</p>
                  <p>Regular Fries</p>
                  <p>Regular Drink</p>
                  <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold text-lg pl-2">
                    {burger.mealPrice}
                  </p>
                </div>
                <div className="flex flex-col justify-between font-fancy">
                  <p className="text-lg font-bold">{burger.name}</p>
                  <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold text-lg pl-2">
                    {burger.burgerPrice}
                  </p>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}

export default Burger;
